export const AuthProviders = {
  Lublin_mfa: "Lublin_mfa",
};
